/* Inspection only: all transforms belong to a separate visual snapshot. */
(function () {
  'use strict';
  const $ = selector => document.querySelector(selector);
  let scene, sourceWidth = 0, sourceHeight = 0, fit = 1, zoom = 1, x = 0, y = 0;
  const pointers = new Map();
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  function paint() {
    if (!scene) return;
    const stage = $('#enlarge-container');
    const scale = fit * zoom;
    const limitX = Math.max(0, (sourceWidth * scale - stage.clientWidth) / 2);
    const limitY = Math.max(0, (sourceHeight * scale - stage.clientHeight) / 2);
    x = clamp(x, -limitX, limitX); y = clamp(y, -limitY, limitY);
    scene.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px) scale(${scale})`;
    stage.dataset.zoomed = String(zoom > 1);
    $('[data-preview-zoom]').textContent = Math.round(zoom * 100) + '%';
    $('[data-preview-out]').disabled = zoom <= 1;
    $('[data-preview-in]').disabled = zoom >= 4;
  }
  function reset() {
    if (window.RoboPixel360?.reset()) return;
    if (!scene) return;
    const stage = $('#enlarge-container');
    fit = Math.min(Math.max(1, stage.clientWidth - 24) / sourceWidth, Math.max(1, stage.clientHeight - 24) / sourceHeight);
    zoom = 1; x = 0; y = 0; pointers.clear(); paint();
  }
  function zoomAt(value, anchorX = 0, anchorY = 0) {
    const next = clamp(value, 1, 4), ratio = next / zoom;
    x = anchorX - (anchorX - x) * ratio;
    y = anchorY - (anchorY - y) * ratio;
    zoom = next; paint();
  }
  function zoomBy(delta) { if (window.RoboPixel360?.zoomBy(delta)) return; if (scene) zoomAt(zoom + delta); }
  function copyStyle(from, to, properties) {
    const style = getComputedStyle(from);
    properties.forEach(property => { to.style[property] = style[property]; });
  }
  function open() {
    const original = $('#mockup-container'), design = $('#design-image'), overlay = $('#mockup-overlay');
    if (!original || !design?.getAttribute('src') || design.style.display === 'none') return;
    const clip = original.querySelector('.design-clip-zone');
    const rect = original.getBoundingClientRect();
    if (!clip || !rect.width || !rect.height) return;
    window.RoboPixel360Inline?.suspend();
    const modal = $('#enlarge-modal'), stage = $('#enlarge-container');
    sourceWidth = rect.width; sourceHeight = rect.height;
    stage.replaceChildren();
    scene = document.createElement('div'); scene.className = 'cz-preview-scene';
    scene.style.width = sourceWidth + 'px'; scene.style.height = sourceHeight + 'px';
    const zone = document.createElement('div'); zone.className = 'cz-preview-clip';
    copyStyle(clip, zone, ['top','left','width','height','clipPath','borderRadius','overflow']);
    const photo = document.createElement('img'); photo.src = design.currentSrc || design.src; photo.alt = ''; photo.draggable = false;
    copyStyle(design, photo, ['top','left','width','height','transform','transformOrigin','objectFit','borderRadius']);
    // Keep the existing protection for generated previews when displaying their twin.
    if (typeof rpShieldPreviewSurface === 'function') rpShieldPreviewSurface(photo, () => rpHasCleanTwin(design.src));
    zone.appendChild(photo); scene.appendChild(zone);
    if (overlay?.src) {
      const frame = document.createElement('img'); frame.className = 'cz-preview-frame';
      frame.src = overlay.currentSrc || overlay.src; frame.alt = overlay.alt; frame.draggable = false;
      scene.appendChild(frame);
    }
    stage.appendChild(scene);
    modal.classList.add('active');
    reset();
    window.RoboPixel360?.attach(stage, scene);
  }
  function close() {
    window.RoboPixel360?.close();
    $('#enlarge-modal').classList.remove('active');
    $('#enlarge-container').replaceChildren(); scene = null; pointers.clear();
    window.RoboPixel360Inline?.resume();
  }
  function refresh() {
    if (!scene) return;
    const original = $('#mockup-container'), design = $('#design-image'), overlay = $('#mockup-overlay');
    const clip = original?.querySelector('.design-clip-zone'), zone = scene.querySelector('.cz-preview-clip');
    if (!clip || !zone) return;
    const rect = original.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    sourceWidth = rect.width; sourceHeight = rect.height;
    scene.style.width = sourceWidth + 'px'; scene.style.height = sourceHeight + 'px';
    copyStyle(clip, zone, ['top','left','width','height','clipPath','borderRadius','overflow']);
    const photo = zone.querySelector('img');
    photo.src = design.currentSrc || design.src;
    copyStyle(design, photo, ['top','left','width','height','transform','transformOrigin','objectFit','borderRadius']);
    const frame = scene.querySelector('.cz-preview-frame');
    if (frame && overlay?.src) frame.src = overlay.currentSrc || overlay.src;
  }
  function point(event) {
    const rect = $('#enlarge-container').getBoundingClientRect();
    return { x: event.clientX - rect.left - rect.width / 2, y: event.clientY - rect.top - rect.height / 2 };
  }
  function pair() {
    const [a,b] = [...pointers.values()];
    return { x: (a.x+b.x)/2, y: (a.y+b.y)/2, distance: Math.hypot(b.x-a.x,b.y-a.y) };
  }
  function init() {
    const stage = $('#enlarge-container');
    stage.addEventListener('pointerdown', event => {
      if (!scene || window.RoboPixel360?.isActive() || (event.pointerType === 'mouse' && event.button !== 0)) return;
      event.preventDefault(); pointers.set(event.pointerId, point(event)); stage.setPointerCapture(event.pointerId);
    });
    stage.addEventListener('pointermove', event => {
      if (!pointers.has(event.pointerId)) return;
      event.preventDefault();
      const before = pointers.size >= 2 ? pair() : pointers.get(event.pointerId);
      pointers.set(event.pointerId, point(event));
      if (pointers.size >= 2) {
        const after = pair();
        if (before.distance > 0) zoomAt(zoom * after.distance / before.distance, before.x, before.y);
        x += after.x-before.x; y += after.y-before.y;
      } else if (zoom > 1) {
        const after = pointers.get(event.pointerId); x += after.x-before.x; y += after.y-before.y;
      }
      paint();
    });
    ['pointerup','pointercancel','lostpointercapture'].forEach(type => stage.addEventListener(type, event => pointers.delete(event.pointerId)));
    // WebGL fits its own viewport on each frame. Resizing its footer must not
    // reset the angle or turn off auto-rotation; only refit the flat snapshot.
    const refitFlat = () => { if (scene && !window.RoboPixel360?.isActive()) reset(); };
    if ('ResizeObserver' in window) new ResizeObserver(refitFlat).observe(stage);
    window.addEventListener('resize', refitFlat);
  }
  window.RoboPixelPreview = { open, close, zoomBy, reset, refresh };
  if (typeof window.RoboPixelCustomizerReady === 'function') window.RoboPixelCustomizerReady(init);
  else document.addEventListener('robopixel:customizer-ready', init, { once: true });
})();
